import Lenis from "@studio-freight/lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

//
export function initSmoothScrolling() {
  LENIS = new Lenis({
    direction: "vertical",
    lerp: 0.058,
    easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    smoothTouch: true,
    normalizeWheel: true,
  });

  LENIS.on("scroll", () => ScrollTrigger.update());

  function raf(time) {
    LENIS.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);
  //
  gsap.ticker.add((time) => {
    LENIS.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);
}
